import { Button, styled } from '@mui/material'
import headerBg from 'img/header-bg.png'

export const StyledHeader = styled('header')({
  backgroundColor: 'var(--light-blue)',
  backgroundImage: `url(${headerBg})`,
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
  backgroundPosition: 'top right',
  padding: '7px 0',
  ['@media (max-width: 1199px)']: {
    padding: '10px 0'
  }
})

export const StyldeImage = styled('img')(({ theme }) => ({
  maxWidth: '195px',
  transition: 'all 0.3s ease',
  [theme.breakpoints.down('lg')]: {
    maxWidth: '160px'
  }
}))

// sx={{
//   color: 'var(--white)',
//   borderColor: 'var(--white)',
//   fontWeight: 700,
//   '&:hover': { borderColor: 'lightgray' }
// }}

export const StyledLogoutButton = styled(Button)(({ theme }) => ({
  color: 'var(--white)',
  borderColor: 'var(--blue)',
  backgroundColor: 'var(--blue)',
  fontWeight: 700,
  '&:hover': {
    borderColor: 'var(--dark-blue)',
    backgroundColor: 'var(--dark-blue)'
  }
}))

export const StyledBurgerButton = styled(Button)(({ theme }) => ({
  padding: '0',
  margin: 0,
  minWidth: 'auto'
}))
